<script>
    import Card from './Card.svelte';
    import PurchasePaddle from './PurchasePaddle.svelte';
    import { format_price } from './utils/format_price';
    import ProductIcon from './ProductIcon.svelte';
    import { format_age_range } from './utils/format_ages';
    import { logEvent } from '$lib/utils/logs';

    let className = '';
    export { className as class };
    export let feature = 'courses-list';

    /** @type {Course[] | null | undefined} */
    export let courses = [];
    export let h_level = 2;

    export let price_only = false;
    export let show_actions = true;
    export let show_first_lesson_cta = false;
    export let first_lesson_cta = 'Try for free';
    export let mark_purchased = true;
    export let icon_class = '';

    function track_first_lesson_click(slug) {
        logEvent(`courses-first-lesson-click-${feature}`, {
            slug
        });
    }
</script>

{#each courses || [] as course}
    {@const course_for_icon = mark_purchased
        ? course
        : { ...course, purchased: false }}
    <Card
        p_sm
        href={`/courses/${course.slug}`}
        click_event={{ name: `courses-card-click-${feature}`, data: { slug: course.slug } }}
        aria_label={course.title}
        class="flex flex-col relative {className}"
    >
        <ProductIcon
            product={course_for_icon}
            class="mx-auto my-4 pointer-events-none {icon_class}"
        />

        <div>
            <svelte:element
                this={`h${h_level}`}
                class="link link-el mb-2 font-extrabold text-xl pointer-events-none"
            >
                {@html course.title}
            </svelte:element>

            {#if course.min_age || course.max_age}
                <span
                    class="text-sm mb-1 bg-surface-highlight rounded-bl-xl px-2 py-1 -ml-1 w-fit absolute top-0 right-0 text-nowrap"
                >
                    {format_age_range(course.min_age, course.max_age)}
                </span>
            {/if}

            {@html course.lead}
        </div>
        {#if course.price && price_only && !course.purchased}
            <p class="mt-4 flex items-end flex-1">
                <span class="text-lg font-extrabold"
                    >{format_price(
                        course.price.price,
                        course.price.price_fx,
                        'code'
                    )}</span
                >
            </p>
        {:else if show_actions || show_first_lesson_cta}
            <p class="mt-4 flex items-end flex-1">
                {#if show_first_lesson_cta && course.lessons_count > 0}
                    <a
                        class="btn btn-outline relative"
                        href="/courses/{course.slug}/lessons"
                        on:click={() => track_first_lesson_click(course.slug)}
                    >
                        {first_lesson_cta}
                    </a>
                {:else if course.price && !course.purchased}
                    <PurchasePaddle
                        product={course}
                        style="small"
                        cta="Buy Now"
                        cta_free="Get for Free"
                        {feature}
                    />
                {:else if course.purchased && !price_only}
                    <a
                        class="btn btn-primary-outline relative"
                        href="/courses/{course.slug}/lessons"
                        >Continue Your Journey</a
                    >
                {:else if !course.price}
                    <a
                        class="btn btn-outline relative"
                        href="/courses/{course.slug}#form"
                        >Join Waitlist</a
                    >
                {/if}
            </p>
        {/if}
    </Card>
{/each}
